import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WizzardCollapseModule } from './wizzardCollapse';
import { WizzardErrorsModule } from './wizzardErrors';
import { WizzardHeaderModule } from './wizzardHeader';
import { WizzardHintsModule } from './wizzardHints';
import { WizzardQuantityModule } from './wizzardQuantity';
import { WizzardSpecialInstructionsModule } from './wizzardSpecialInstructions';
import { WizzardSubNavModule } from './wizzardSubNav';
import { WizzardWrapperModule } from './wizzardWrapper';

const toExport: any[] = [
    WizzardCollapseModule,
    WizzardErrorsModule,
    WizzardHeaderModule,
    WizzardHintsModule,
    WizzardQuantityModule,
    WizzardSpecialInstructionsModule,
    WizzardSubNavModule,
    WizzardWrapperModule,
];

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        ...toExport
    ],
    exports: [
        ...toExport
    ],
    providers: [],
})
export class WizzardComponentsModule { }
